
import React from "react";
import { Address } from "../../../types/userType";
interface AddressProp {
  item:Address,
  auth:string
}
export const UserAddressCard:React.FC<AddressProp> = ({item,auth}) => {
  return (
    <div className="p-5 border rounded-md flex ">
      <div className="space-y-3 pt-3">
        <h1>{auth}</h1>
        <p className="w-[320px] text-gray-500">{item.streetName}, {item.city}, {item.country} - {item.postalCode}</p>
        <p className="text-gray-500">
          <strong>Mobile:</strong> {item.mobile}
        </p>
      </div>
    </div>
  );
};
